export type StepMapping = {
  stepName?: string;
  iSheetType?: string;
};

export const STEP_MAPPING: Record<string, StepMapping> = {
  "CreateGroup": { stepName: "CreateGroup" },
  "AddUserToGroup": { stepName: "CreateGroup" },

  "Create View Information Request List": { stepName: "CreateView", iSheetType: "Information Request List" },
  "Create View Project Status": { stepName: "CreateView", iSheetType: "Project Status" },
  "Create View K-1 Tracker": { stepName: "CreateView", iSheetType: "K-1 Tracker" },
  "Create View Deliverables": { stepName: "CreateView", iSheetType: "Deliverables" },

  "Update View Permission Information Request List": { stepName: "UpdateViewPermission", iSheetType: "Information Request List" },
  "Update View Permission Project Status": { stepName: "UpdateViewPermission", iSheetType: "Project Status" },
  "Update View Permission K-1 Tracker": { stepName: "UpdateViewPermission", iSheetType: "K-1 Tracker" },
  "Update View Permission Deliverables": { stepName: "UpdateViewPermission", iSheetType: "Deliverables" },

  "UpdateFolderPermission": { stepName: "UpdateFolderPermission" },

  "Create Navigation Information Request List": { stepName: "CreateView", iSheetType: "Information Request List" },
  "Create Navigation Project Status": { stepName: "CreateView", iSheetType: "Project Status" },
  "Create Navigation K-1 Tracker": { stepName: "CreateView", iSheetType: "K-1 Tracker" },
  "Create Navigation Deliverables": { stepName: "CreateView", iSheetType: "Deliverables" },
};

export const STEP_MAPPING_History: Record<string, StepMapping> = {
  ...STEP_MAPPING,
  "AddUserToGroup": { stepName: "addusertogroup" },

  "Create Navigation Information Request List": { stepName: "CreateNavigation", iSheetType: "Information Request List" },
  "Create Navigation Project Status": { stepName: "CreateNavigation", iSheetType: "Project Status" },
  "Create Navigation K-1 Tracker": { stepName: "CreateNavigation", iSheetType: "K-1 Tracker" },
  "Create Navigation Deliverables": { stepName: "CreateNavigation", iSheetType: "Deliverables" },
};

const mapStep = (stepName: string | null | undefined, mapping: Record<string, StepMapping>): StepMapping => {
  const key = stepName ?? "";
  const map = mapping[key] || {};

  return {
    stepName: map.stepName ? map.stepName : "",
    iSheetType: map.iSheetType ? map.iSheetType : "All",
  };
};

export function getStepMapping(stepName: string | null): StepMapping {
  return mapStep(stepName, STEP_MAPPING);
}

export function getStepMappingForHistory(stepName: string | null | undefined): StepMapping {
  return mapStep(stepName, STEP_MAPPING_History);
}
